import { styled } from '@mui/material';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';
import Section5 from './Section5';
import Section6 from './Section6';

const HeroSection = styled('section')(({ theme }) => ({
  background: 'url("https://bucket.ywhdev.com/wl/?id=ID8JHjM3zDnjVdzqr6aVU4ql2HFQGVMu&fmode=open")',
  overflow: 'hidden',
  height: 700,
  [theme.breakpoints.down('sm')]: {
    height: 450,
  },
  alignItems: 'flex-end',
  display: 'flex',
  justifyContent: 'center',
  paddingBottom: 80,
  position: 'relative',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  borderBottom: '8px solid #5284e0',
  gap: 8,
  textAlign: 'center',
  [theme.breakpoints.down('lg')]: {
    backgroundPosition: 'top center',
  },
  '& div.header': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    h1: {
      color: 'white',
      fontFamily: 'Playfair Display',
      zIndex: 2,
      fontSize: 48,
      lineHeight: '60px',
      fontWeight: 700,
    },
    h3: {
      color: '#CDA07D',
      zIndex: 2,
      fontSize: 24,
      lineHeight: '36px',
      fontWeight: 600,
    },
  },
}));

const NineMinuteDrill = () => {
  return (
    <div>
      <HeroSection>
        <div className="header">
          <h1>Nine-Minute Showing Drill</h1>
          <h3>A checklist for a last minute showing schedule of your home</h3>
        </div>
      </HeroSection>
      <div>
        <Section1 />
        <Section2 />
        <Section3 />
        <Section4 />
        <Section5 />
        <Section6 />
      </div>
    </div>
  );
};

export default NineMinuteDrill;
